import { useState, useCallback } from 'react'

export default (startingIsOpen) => {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  return { open, close, isOpen, setIsOpen }
}
